export default "__VITE_ASSET__BeSdJb5d__"